import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';
import HistogramBrokenLine from './HistogramBrokenLine';
import { genModules, genSubAuth } from '../../constants';

const Icons = [
    { icon: '\ue659', order: 0, key: 'table' },
    { icon: '\ue652', order: 1, key: 'histogramSpline' },
];

class UnregisterRequest extends Component {
    static contextTypes = {
        businessList: PropTypes.array,
        clientHeight: PropTypes.number,
        notice: PropTypes.object,
    }

    constructor(props) {
        super(props);
        const { auth } = props;
        this.icons = genModules(Icons, auth);
        this.state = {
            current: 0,
            searchParams: {},
        };
    }

    handleIconChange = (current) => {
        this.setState({ current });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    render() {
        const { businessList, clientHeight, notice } = this.context;
        const { auth } = this.props;
        const { current, searchParams } = this.state;

        return (
            <div className="pane-item">
                <HeaderBar
                    title="剩余待请款合同表单"
                    tip="已审核通过但未登记请款的合同"
                    onChange={this.handleIconChange}
                    current={current}
                    icons={this.icons}
                />
                {
                    current === 0 &&
                    <TablePage
                        notice={notice}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        businessList={businessList}
                        onChange={this.handleChange}
                    />
                }
                {
                    current === 1 &&
                    genSubAuth(auth, 'histogramSpline') &&
                    <HistogramBrokenLine
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                    />
                }
            </div>
        );
    }
}

export default UnregisterRequest;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/UnregisterRequest/index.js